<template>
    <div>
        <!--<div class="clearfix2 min_1200 footer box_mt60 box_ph25 black6_text black6_link">-->
            <!--<div class="w_1200">-->
                <!--<div class="fl">&copy; CopyRight <span v-text="new Date().getFullYear()"></span> <a href="javascript:void(0);" target="_blank">云浮市公共资源交易中心版权所有</a></div>-->
                <!--<div class="r_cell box_r">粤ICP备 05070829号-2<span class="box_ml20">-->
                    <!--<img src="../assets/images/icon/beian.png" alt="" class="box_mr8">粤公网安备 <a href="javascript:void(0);" target="_blank">44010402001768号</a></span>-->
                <!--</div>-->
            <!--</div>-->
        <!--</div>-->
        <div class="clearfix2 min_1200 footer box_mt60 box_ph25 black6_text black6_link">
            <div class="w_1200">
                <div style="text-align: center;">&copy; CopyRight <span v-text="new Date().getFullYear()"></span> <a href="javascript:void(0);" target="_blank">汕尾市公共资源交易中心版权所有</a></div>
            </div>
        </div>
        <!--end文件底-->


        <!-- ftool -->
        <div class="ftool" id="ftool">
            <a href="#" class="ftool_top ftool_item" id="ftoolTop">
                <span class="ftoolab"><i class="ftoolico"></i></span>
            </a>
        </div>
        <!-- end ftool -->
    </div>
</template>

<script>
    export default {
        name: "Footer"
    }
</script>

<style scoped>

</style>
